let placeholder = document.getElementById('nav-placeholder');
let pageBanner = document.getElementById('page-banner');
/** @type {HTMLElement} */
let nav = document.querySelector('body header nav');

if (placeholder !== null && nav && pageBanner === null) {
  nav.style.position = 'relative';
  nav.style.backgroundColor = 'var(--bs-primary)';
}
